var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMark16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 8,
    cy: 10.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4.5h2v3a1 1 0 11-2 0v-3z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.755 1.75c1.863 0 2.927.234 3.822.713a4.712 4.712 0 011.96 1.96c.473.884.713 1.933.713 3.332 0 1.863-.234 2.927-.713 3.822a4.712 4.712 0 01-1.96 1.96c-.884.473-1.933.713-3.332.713-1.863 0-2.927-.234-3.822-.713a4.712 4.712 0 01-1.96-1.96c-.473-.884-.713-1.933-.713-3.332 0-1.863.234-2.927.713-3.822a4.712 4.712 0 011.96-1.96c.884-.473 1.933-.713 3.332-.713z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark16);
export default __webpack_public_path__ + "static/media/exclamation-mark-16.8293515f.svg";
export { ForwardRef as ReactComponent };